import {
  getRegisteredProductBySlug
} from "./chunk-6UZ4MMYO.js";

// src/product-routing.ts
var BUILTIN_PRODUCT_SLUGS = {
  "exxat-prism": "prism",
  "exxat-design-os": "design-os",
  "exxat-admin": "admin",
  "exxat-people": "people",
  "exxat-courses": "courses",
  "exxat-personnel": "personnel",
  "exxat-one-sites": "one-sites",
  "exxat-curriculum-mapping": "curriculum-mapping",
  "exxat-compliance": "compliance",
  "exxat-surveys": "surveys",
  "exxat-exam-management": "exam-management",
  "exxat-accreditation": "accreditation",
  "exxat-student-success": "student-success"
};
function builtInProductSlug(product) {
  if (product === "exxat-custom") return "custom";
  return BUILTIN_PRODUCT_SLUGS[product];
}
var RESERVED_PRODUCT_ROOT_SEGMENTS = /* @__PURE__ */ new Set([
  "library",
  "settings",
  "help",
  "columns",
  "tokens-themes",
  "login",
  "logout",
  "oauth",
  "dashboard",
  "custom",
  "design-os",
  "admin",
  "people",
  "courses",
  "personnel",
  "exam",
  "one",
  "prism",
  // Retired: kept reserved so a tenant custom product cannot claim the slug and
  // resurrect dead One — Schools deep links under a different product.
  "one-schools",
  "one-sites",
  "curriculum-mapping",
  "compliance",
  "surveys",
  "exam-management",
  "accreditation",
  "student-success"
]);
var BUILTIN_SLUGS = {
  prism: "exxat-prism",
  "design-os": "exxat-design-os",
  admin: "exxat-admin",
  people: "exxat-people",
  courses: "exxat-courses",
  personnel: "exxat-personnel",
  "one-sites": "exxat-one-sites",
  "curriculum-mapping": "exxat-curriculum-mapping",
  compliance: "exxat-compliance",
  surveys: "exxat-surveys",
  "exam-management": "exxat-exam-management",
  accreditation: "exxat-accreditation",
  "student-success": "exxat-student-success",
  custom: "exxat-custom"
};
var TENANT_SUFFIX_BLOCKED_SLUGS = /* @__PURE__ */ new Set([
  "prism",
  "design-os",
  "admin",
  "people",
  "courses",
  "personnel",
  "one-schools",
  "one-sites",
  "curriculum-mapping",
  "compliance",
  "surveys",
  "exam-management",
  "accreditation",
  "student-success",
  "custom",
  "exam",
  "one"
]);
function isBuiltInProductSlug(slug) {
  return slug in BUILTIN_SLUGS;
}
function customSuffixCollidesWithBuiltInProduct(suffix) {
  const trimmed = suffix.trim();
  if (!trimmed) return false;
  return TENANT_SUFFIX_BLOCKED_SLUGS.has(customProductSlugFromSuffix(trimmed));
}
function isReservedProductRootSegment(slug) {
  return RESERVED_PRODUCT_ROOT_SEGMENTS.has(slug);
}
function customProductSlugFromSuffix(suffix) {
  const slug = suffix.trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  return slug || "custom-product";
}
function resolveProductFromPath(pathname, customProducts = []) {
  const segment = pathname.replace(/^\/+/, "").split("/", 1)[0] ?? "";
  if (!segment) return null;
  for (let i = 0; i < customProducts.length; i++) {
    const brand = customProducts[i];
    if (!brand?.suffix?.trim()) continue;
    if (customProductSlugFromSuffix(brand.suffix) === segment) {
      return { product: "exxat-custom", customIndex: i };
    }
  }
  const builtIn = BUILTIN_SLUGS[segment];
  if (builtIn) {
    return { product: builtIn };
  }
  if (getRegisteredProductBySlug(segment)) {
    const mirrorIndex = customProducts.findIndex(
      (brand) => brand?.suffix?.trim() && customProductSlugFromSuffix(brand.suffix) === segment
    );
    if (mirrorIndex >= 0) {
      return { product: "exxat-custom", customIndex: mirrorIndex };
    }
  }
  return null;
}
function productRouteSlug(product, customProducts = [], activeCustomIndex = 0) {
  if (product === "exxat-custom") {
    const brand = customProducts[activeCustomIndex] ?? customProducts[0];
    if (brand?.suffix?.trim()) {
      return customProductSlugFromSuffix(brand.suffix);
    }
    return "custom";
  }
  return builtInProductSlug(product);
}
function validateCustomProductSuffix(suffix, customProducts, excludeIndex) {
  const trimmed = suffix.trim();
  if (!trimmed) return "Enter a product name after Exxat.";
  const slug = customProductSlugFromSuffix(trimmed);
  if (customSuffixCollidesWithBuiltInProduct(trimmed)) {
    return `"${trimmed}" conflicts with a reserved route \u2014 pick another name.`;
  }
  if (isReservedProductRootSegment(slug)) {
    return `"${trimmed}" conflicts with a reserved route \u2014 pick another name.`;
  }
  const duplicate = customProducts.some(
    (cp, i) => i !== excludeIndex && cp.suffix?.trim() && customProductSlugFromSuffix(cp.suffix) === slug
  );
  if (duplicate) {
    return `A product named "${trimmed}" already exists.`;
  }
  return null;
}

export {
  RESERVED_PRODUCT_ROOT_SEGMENTS,
  isBuiltInProductSlug,
  customSuffixCollidesWithBuiltInProduct,
  isReservedProductRootSegment,
  customProductSlugFromSuffix,
  resolveProductFromPath,
  productRouteSlug,
  validateCustomProductSuffix
};
